/* esm.sh - @use-gesture/core@10.3.1/dist/maths-0ab39ae9.esm */
export * from "/*@use-gesture/core@10.3.1/esnext/dist/maths-0ab39ae9.esm.mjs";
